import React from 'react';

class OfferBox extends React.Component {
    
    render() {
        var buttonClass = this.props.selected ? 'offerBtn selected' : 'offerBtn'
  
        return (
            <button className={buttonClass} onClick={this.props.handleOfferSelection}>
                <span className="percentage">{this.props.percentage}%</span>
                <span className="time">{this.props.length} year</span>
                <span className="price">${this.props.offer}</span>
                <span className="regular-price">${this.props.price}</span>
            </button>
        )
    }
  }

  export default OfferBox